module.exports = __webpack_public_path__ + "static/media/chat.5da6a12c.png";